import { __ } from '@wordpress/i18n'

import React from 'react'
import PropTypes from 'prop-types'
import { renderRichText } from 'gutenberg/utils'
import { Wrapper, Image, Title, PlayBtn, Badge } from './custom.styled'
import Button from '../Button'
import Fancybox from '../Fancybox'

const FeaturedItem = ({
  image,
  title,
  linkText,
  link,
  bgColor,
  videoLink,
  topBadge,
  isEditor = false,
}) => {
  return (
    <Wrapper className="featured-item" bgColor={bgColor} isEditor={isEditor}>
      {topBadge && <Badge>{__('Top', 'dhsv_theme')}</Badge>}
      <Fancybox options={{ groupAttr: false }}>
        <Image>
          {image.url && <img src={image.url} alt={image.title} />}
          {videoLink && <PlayBtn data-fancybox href={videoLink}></PlayBtn>}
        </Image>
        {renderRichText(title, Title)}
        {videoLink && !link.url ? (
          <a
            className="btn btn-primar"
            data-text={__('Play Video', 'dhsv_theme')}
            data-fancybox
            href={videoLink}
          >
            <span>{__('Play Video', 'dhsv_theme')}</span>
          </a>
        ) : (
          link.url && (
            <Button
              title={linkText}
              link={link}
              bgColor="var(--primary)"
              isEditor={isEditor}
            />
          )
        )}
      </Fancybox>
    </Wrapper>
  )
}

FeaturedItem.propTypes = {
  image: PropTypes.object,
  title: PropTypes.string,
  linkText: PropTypes.string,
  link: PropTypes.object,
  bgColor: PropTypes.string,
  videoLink: PropTypes.string,
  topBadge: PropTypes.bool,
  isEditor: PropTypes.bool,
}

export default FeaturedItem
